var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',_vm._l((_vm.logData),function(d){return _c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.openLog(d.filename)}}},[_vm._v(_vm._s(d.date))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }